import { useState } from "react";
import { NavLink } from "react-router-dom";
import { ArrowRight, Mail, Menu, Phone, X } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "../../lib/brand";
import { useQuote } from "../../context/QuoteContext";

const LINKS = [["/", "Overview"], ["/vehicles", "Vehicles"], ["/products", "Products"], ["/tenders", "GeM & Tenders"], ["/services", "Services"], ["/contact", "Contact"]];

export function Header() {
  const [open, setOpen] = useState(false);
  const { openQuote } = useQuote();
  return (
    <>
      <div className="topbar">
        <div className="wrap topbar-inner">
          <span>Fire safety vehicles · Equipment · Manpower</span>
          <span className="quick-links">
            <a href={CONTACT.tel} data-testid="header-phone-link"><Phone size={13} /> {CONTACT.phone}</a>
            <a href={`mailto:${CONTACT.info}`} data-testid="header-email-link"><Mail size={13} /> {CONTACT.info}</a>
            <a href={`mailto:${CONTACT.sales}`} data-testid="header-sales-email-link"><Mail size={13} /> {CONTACT.sales}</a>
          </span>
        </div>
      </div>
      <header className="site-header">
        <div className="wrap nav-row">
          <Logo />
          <button className="menu-btn" onClick={() => setOpen(!open)} data-testid="mobile-menu-button" aria-label="Toggle menu">{open ? <X /> : <Menu />}</button>
          <nav className={open ? "nav open" : "nav"}>
            {LINKS.map(([to, label]) => (
              <NavLink key={to} to={to} end={to === "/"} onClick={() => setOpen(false)} data-testid={`nav-${label.toLowerCase().replaceAll(" ", "-")}`}>{label}</NavLink>
            ))}
            <button className="button button-orange nav-quote" onClick={() => { setOpen(false); openQuote({ source: "header" }); }} data-testid="nav-quote-button">Get a quote <ArrowRight size={16} /></button>
          </nav>
        </div>
      </header>
    </>
  );
}
